"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nList = I18nList;
var _request = _interopRequireDefault(require("@/plugins/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function I18nList(data) {
  return (0, _request.default)({
    url: '/api/system/i18n/list',
    method: 'post',
    data
  });
}